import { createSlice } from 'utils/@reduxjs/toolkit';
import { AvailableLanguagesState } from './types';
import { reducers } from './reducers';

export const initialState: AvailableLanguagesState = {
  isLoading: false,
  error: null,
  data: [{ label: 'Netherlands', value: 'nl' }],
};

const slice = createSlice({
  name: 'availableLanguages',
  initialState,
  reducers,
});

export const { actions: availableLanguagesActions } = slice;
export const { reducer: availableLanguagesReducer } = slice;
